<script lang="ts" setup>
import { computed } from 'vue'

import type { TeamSide } from '@collector/shared-domain'

import FieldZoneButton from './FieldZoneButton.vue'

type Props = {
  incidentParticipantTeamSide: TeamSide
  teamSidesChanged: boolean
}
const props = defineProps<Props>()

// model
const selectedZoneModel = defineModel<number | null>('selectedZone', {
  default: null,
})

// computed
const reversed = computed(() => props.incidentParticipantTeamSide === 'away')
const localSidesSwitched = computed(
  () => reversed.value !== props.teamSidesChanged,
)

// methods
function handleZoneSelection(zone: number): void {
  if (selectedZoneModel.value === zone) {
    selectedZoneModel.value = null
  } else {
    selectedZoneModel.value = zone
  }
}
</script>

<template>
  <div
    class="absolute inset-0 h-full w-full p-1"
    :class="{
      'scale-x-[-1] scale-y-[-1] transform': localSidesSwitched,
    }"
  >
    <div
      class="grid h-full w-1/2 grid-cols-[2fr_1fr] grid-rows-[repeat(3,1fr)] gap-1"
    >
      <FieldZoneButton
        v-for="i in [5, 4, 6, 3, 1, 2]"
        :key="i"
        :class="{
          'scale-x-[-1] scale-y-[-1] transform': localSidesSwitched,
        }"
        :selected="selectedZoneModel === i"
        @click="handleZoneSelection(i)"
      >
        {{ i }}
      </FieldZoneButton>
    </div>
  </div>
</template>
